var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1130,
    height: 721,
    viewBox: "0 0 1130 721",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_863_1573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.802 348.924C313.708 275.668 161.722 321.809 224.724 204.329C287.726 86.8479 743.124 90.0288 878.218 163.285C1013.31 236.542 776.944 352.133 713.942 469.614C650.94 587.095 583.896 422.181 448.802 348.924Z",
    fill: "url(#paint0_linear_863_1573)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_863_1573",
    x: 0.0449219,
    y: -98.4307,
    width: 1129.21,
    height: 819.051,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 105,
    result: "effect1_foregroundBlur_863_1573"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_863_1573",
    x1: 938.26,
    y1: 195.844,
    x2: 675.949,
    y2: 585.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F60F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.0e6675af685b278dba04e4967cdc47b1.svg";
export { ForwardRef as ReactComponent };